import {BaseSearchableService} from "./Core/BaseSearchableService";

class ConfirmationAgencyService extends BaseSearchableService {
    get ModelName() { return "Confirmation Agency"; }
    get PrimaryKeyProperty() { return "confirmationAgencyId"; }
    get TitleProperty() { return "name"; }
    get Url() { return super.Url + "/confirmationAgency"; }
}

export const service = new ConfirmationAgencyService();

